import React from "react";
import { ClipLoader } from "react-spinners";
import { SiRazorpay } from "react-icons/si";

const Loader = ({ loading, page }) => {
  if (!loading) return null;

  return (
    <div className="flex flex-col justify-center items-center h-screen w-full bg-white">
      <div className="rounded-full shadow-2xl p-6 mb-4 flex items-center justify-center animate-loader">
        <ClipLoader color="blue" loading={loading} size={20} />
      </div>

      {page === "monetization" && (
        <div className="flex items-center justify-center text-gray-600 text-[14px] font-roboto">
          <span className="mr-1">Fetching data from</span>
          <span className="flex items-center space-x-1 mr-2">
            <SiRazorpay color="#323299" />
            <span className="text-[#007bff] font-medium italic">Razorpay</span>
          </span>
          <span>Please wait...</span>
          {/* Optional loader: */}
          {/* <Spinner className="ml-2" /> */}
        </div>
      )}

      {page === "verify" && (
        <div className="flex items-center justify-center text-gray-600 text-[14px] font-roboto">
          <span className=" font-medium ">Verifying...</span>

          {/* Optional loader: */}
          {/* <Spinner className="ml-2" /> */}
        </div>
      )}
    </div>
  );
};

export default Loader;
